import { ref, readonly } from 'vue'
import { deserializeResponse } from '~/utils/api/deserializeResponse'

export const usePermissionsApi = () => {
  const authStore = useAuthStore()
  const loading = ref(false)
  const error = ref(null)

  const getMyPermissions = async () => {
    loading.value = true
    error.value = null

    try {
      const config = useRuntimeConfig()
      const response = await $fetch('/auth/permissions', {
        method: 'GET',
        baseURL: config.public.apiBase,
        headers: {
          Authorization: `Bearer ${authStore.accessToken}`
        }
      })

      const permissionsData = await deserializeResponse(response)
      return permissionsData
    } catch (e) {
      error.value = e
      throw e
    } finally {
      loading.value = false
    }
  }

  return {
    loading: readonly(loading),
    error: readonly(error),
    getMyPermissions,
  }
}
